<template>
<!-- 검색 영역 -->
<div v-loading="isLoading" style="width: 100%; height: 100%;">
  <div :class="$style['search-area']">
    <el-input size="mini" suffix-icon="el-icon-search" v-model="keyword" placeholder="검색 키워드를 입력해주십시오."></el-input>
    <w-map-button
      v-if="elementType === MapConst.ELEMENT_TYPE.MANAGED"
      :pressed="isFilter"
      icon="map-objectmanaged-filter"
      tooltip="맵에 그려져 있지 않은 대상만 필터링합니다."
      @onClick="filterClick(!isFilter)">
    </w-map-button>
  </div>
  <!-- 검색 영역 끝 -->
  <el-scrollbar :class="[$style['el-scrollbar']]">
    <el-tree
      :class="['tree-checkbox', 'map-element-tree']"
      style="height:100%;"
      ref="tree"
      :data="treeData"
      :props="treeProps"
      :node-key="treeProps.treeKey"
      :expand-on-click-node="false"
      :highlight-current="highlightCurrent"
      :filter-node-method="filterNode"
      @current-change="currentChange">
      <span class="el-tree-node__label" slot-scope="{ node, data }" style="padding-left: 10px;">
        <el-popover :disabled="elementType !== MapConst.ELEMENT_TYPE.SUBMAP" placement="right" trigger="hover" @show="showMapPreview(node)" :open-delay="700" :visible-arrow="false" popper-class="preview-popup">
          <div v-loading="previewLoading" class="preview-wrapper">
            <div v-if="previewLoading"></div>
            <span v-else-if="!previewImgSrc" class="no-preview">미리보기 없음</span>
            <img v-else :src="previewImgSrc" class="preview-img"/>
          </div>
          <drag slot="reference" :class="['drag-area']" :draggable="isDragAllow(node)" :transfer-data="transferData(data)" :style="{cursor: isDragAllow(node) ? 'default' : 'not-allowed'}">
            <span slot="image" style="padding: 20px; display: inline-block;">{{ node.label }}</span>
          </drag>
        </el-popover>
        <span>{{ node.label }}</span>
      </span>
    </el-tree>
  </el-scrollbar>
</div>
</template>

<script>
import uniqBy from 'lodash/uniqBy';
import { Drag } from 'vue-drag-drop';

import forEach from 'lodash/forEach';

import TreeAPI from '@/api/common/tree';
import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';

import { Q, MapInfo } from '@/views/topologymap/js/maps';
import WMapButton from '@/views/topologymap/components/MapButton';

export default {
  name: 'WMapElementTree',
  components: {
    Drag,
    WMapButton,
  },
  props: {
    elementType: {
      type: String,
      default: null,
    },
    highlightCurrent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      keyword: null,
      treeData: null,
      MapConst,
      previewImgSrc: null,
      previewLoading: false,
      treeProps: {
        treeKey: 'treeKey',
        children: 'children',
        label: 'label',
      },
      isFilter: false,
      objIdsOfManageObjectModel: [],
    };
  },
  watch: {
    keyword(value) {
      this.$refs.tree.filter(value);
    },
  },
  created() {
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.ADD_ELEMENT_COMPLETE, this.filterClick);
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.REMOVE_ELEMENT_COMPLETE, this.filterClick);
    this.loadData();
  },
  methods: {
    showMapPreview(mouseoverNode) {
      this.previewLoading = true;
      this.previewImgSrc = null;

      MapAPI.getMapPreview(mouseoverNode.data.mapId).then((response) => {
        const result = response.data;

        if (result.success && result.data) {
          this.previewImgSrc = `data:image/png;base64,${result.data}`;
        }

        this.previewLoading = false;
      });
    },
    isDragAllow(node) {
      if (this.elementType === MapConst.ELEMENT_TYPE.SUBMAP) {
        return true;
      }
      return node.isLeaf;
    },
    /**
     * 노드 필터링
     * @author KangBonghun(toto1323)
     * @param  {[type]} value [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     */
    filterNode(value, data) {
      const filterKeyword = (value || this.keyword).toLowerCase();
      let result = false;
      if (!filterKeyword || data.label.toLowerCase().indexOf(filterKeyword) !== -1) {
        result = true;
      }
      if (result && this.isFilter) {
        const objIds = this.objIdsOfManageObjectModel;
        if (data.obj && (objIds.indexOf(data.obj.objId) === -1)) {
          result = true;
        } else {
          result = false;
        }
      }

      return result;
    },
    loadData() {
      this.isLoading = true;
      switch (this.elementType) {
        case MapConst.ELEMENT_TYPE.MANAGED:
          TreeAPI.getLogicalTreeData({}).then((response) => {
            this.treeData = [response.data.children];
            this.expandTree();
          });
          break;
        case MapConst.ELEMENT_TYPE.VIRTUAL:
          MapAPI.getVirtualObjectTree().then((response) => {
            this.treeData = response.data.children;
            this.expandTree();
          });
          break;
        case MapConst.ELEMENT_TYPE.SUBMAP:
          MapAPI.getTopologymapTree().then((response) => {
            this.treeData = response.data.children;
            this.expandTree();
          });
          break;
        case MapConst.ELEMENT_TYPE.CUSTOM:
          this.treeData = [{
            label: '사용자 정의 위젯',
            treeKey: '1',
            children: [],
          }];
          this.isLoading = false;
          break;
        default:
          this.isLoading = false;
          break;
      }
    },
    expandTree() {
      this.$nextTick(() => {
        forEach(this.$refs.tree.root.childNodes, (item) => {
          item.expanded = true;
        });
        this.isLoading = false;
        this.$emit('loadComplete');
      });
    },
    getCurrentNode() {
      return this.$refs.tree.getCurrentNode();
    },
    transferData(treeData) {
      const returnObject = {
        type: null,
        data: [],
      };
      switch (this.elementType) {
        case MapConst.ELEMENT_TYPE.MANAGED:
          returnObject.type = Q.ManagedObjectModel;
          returnObject.data = [treeData.obj];
          break;
        case MapConst.ELEMENT_TYPE.VIRTUAL:
          returnObject.type = Q.VirtualObjectModel;
          returnObject.data = [treeData];
          break;
        case MapConst.ELEMENT_TYPE.SUBMAP:
          returnObject.type = Q.SubTopologymapModel;
          returnObject.data = [treeData];
          break;
        case MapConst.ELEMENT_TYPE.CUSTOM:
          returnObject.type = Q.Custom1Model;
          returnObject.data = [treeData];
          break;
        default:
          break;
      }
      return returnObject;
    },
    filterClick(isFilterFlag) {
      if (typeof isFilterFlag === 'boolean') {
        this.isFilter = isFilterFlag;
      }
      if (this.isFilter) {
        const graph = MapInfo.getInstance(this).getGraph();
        const managedObjectModels = graph.graphModel.toDatas().filter((graphModelData) => graphModelData instanceof Q.ManagedObjectModel);
        this.objIdsOfManageObjectModel = uniqBy(managedObjectModels, (value) => value.get('objId')).map((value) => value.get('objId'));
      }
      this.$refs.tree.filter('');
    },
    currentChange(node) {
      this.$emit('current-change', node);
    },
  },
};
</script>

<style lang="scss">
.map-element-tree {
  &.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #f0f7ff !important;
  }

  .el-tree-node__content {
    position: relative;
    -webkit-transition: background-color .25s ease;
    transition: background-color .25s ease;
    background-color: transparent !important;
    cursor: default;

    &:hover {
      background-color: #f7f7f8 !important //$vlightgray
    }

    .el-tree-node__expand-icon {
      z-index: 1;
    }
  }
  .drag-area {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  // &.tree-checkbox {
  //   border: none;
  // }

  .preview-ref {
    position: absolute;
    left: 0;
    top: 0;
    width: calc(100% - 20px);
    height: 100%;
    z-index: 0;
  }
}
</style>
<style module>
.search-area {
  margin-bottom: 10px;
  display: flex;
}

.el-scrollbar {
  height: calc(100% - 40px);
  /* border: 1px solid #e7e7e7; */
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/MapElementTree.vue